<recrewt-sidenav>
  <router-outlet></router-outlet>
</recrewt-sidenav>
